import React from 'react'

const Text = (props) => {
  return (
        <div data-aos="fade-up">
             {props.text}
        </div>
  )
}

export default Text